import { cleanValueForCsv } from 'pages/auto-rfq/utils';
import {
  EnhancedFieldCsvRow,
  IProductEnhancerField,
  EnhancedFieldsMapState,
  isProductEnhancerField,
  EProductEnhancerFieldTypes
} from '../../../types';

// ! GENERATE CSV
const normalizeCsvValue = (val: string): string => {
  if (val === null || val === undefined) return '';
  return cleanValueForCsv(val.replace(/\r?\n|\r/g, '\\n').trim());
};

export const generateEnhancedFieldsCSV = (
  originalFields: IProductEnhancerField[],
  enhancedFieldsMap: EnhancedFieldsMapState
): EnhancedFieldCsvRow[] => {
  const row = originalFields.reduce<EnhancedFieldCsvRow>(
    (acc, originalField) => {
      const enhancedField = enhancedFieldsMap[originalField.id];

      let mainField: IProductEnhancerField = originalField;
      // if enhanced field is not empty, use it as the main field
      if (enhancedField && isProductEnhancerField(enhancedField)) {
        mainField = enhancedField;
      }

      const { title } = mainField;

      let csvValue: string;

      switch (mainField.type) {
        case EProductEnhancerFieldTypes.TAG:
          csvValue = mainField.data.join(' | ');
          break;
        case EProductEnhancerFieldTypes.LABEL_VALUE:
          csvValue = mainField.data
            .map(({ label, value }) => `${label}: ${value}`)
            .join(' | ');
          break;
        default:
          csvValue = mainField.data;
      }

      acc[title] = normalizeCsvValue(csvValue);
      return acc;
    },
    {}
  );

  return [row];
};
